<template>
  <div v-if="fetching" class="text-blue-400">
    <base-loading class="block text-3xl" />
    Loading
  </div>
  <base-notice v-else-if="clients.length === 0">
    No export clients were added yet
  </base-notice>
  <ul v-else>
    <li v-for="client in clients" :key="client.id" class="mb-1">
      <admin-export-clients-item :client="client" />
    </li>
  </ul>
</template>

<script>
import { computed } from '@vue/composition-api';
import AdminExportClientsItem from './AdminExportClientsItem.vue';

export default {
  components: { AdminExportClientsItem },
  setup(props, { root }) {
    const fetching = computed(() => root.$store.state.company.exports.fetching);
    const clients = computed(() => root.$store.state.company.exports.clients);

    return {
      fetching,
      clients,
    };
  },
};
</script>
